const initialState = {
  bannerList: [],
  bookingListLoading: true,
  bookingList: [],
  tabActive: 0,
};

function reducer(state, action) {
  switch (action.type) {
    case 'setBannerList':
      return { ...state, bannerList: action.payload };
    case 'setBookingListLoading':
      return { ...state, bookingListLoading: action.payload };
    case 'setBookingList':
      return { ...state, bookingList: action.payload };
    case 'setTabActive':
      return { ...state, tabActive: action.payload };
    default:
  }
}

const setBannerList = payload => ({
  type: 'setBannerList',
  payload,
});

const setBookingListLoading = payload => ({
  type: 'setBookingListLoading',
  payload,
});

const setBookingList = payload => ({
  type: 'setBookingList',
  payload,
});

const setTabActive = payload => ({
  type: 'setTabActive',
  payload,
});

export {
  initialState,
  reducer,
  setBannerList,
  setBookingListLoading,
  setBookingList,
  setTabActive
};
